import { useEffect } from 'react';

import { $isAutoLinkNode } from '@lexical/link';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { BLUR_COMMAND, COMMAND_PRIORITY_LOW } from 'lexical';

import { $createTrackingLinkNode } from '../tracking-link';

export const OnBlurPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand<FocusEvent>(
      BLUR_COMMAND,
      () => {
        editor.update(() => {
          editor.getEditorState()._nodeMap.forEach((node) => {
            if ($isAutoLinkNode(node)) {
              node.replace($createTrackingLinkNode(node.getURL()));
            }
          });
        });
        return false;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor]);

  return null;
};
